import { OrderDeliveryInput } from './components/types';

export const calculateCartTotal = (cart: OrderDeliveryInput[]) => {
  if (!cart?.length) return { orderTotal: 0, hasZeroPricedItem: false };

  let orderTotal = 0;
  let hasZeroPricedItem = false;

  cart.forEach((delivery) => {
    delivery.items.forEach((item) => {
      const itemPrice = item.price || 0;
      orderTotal += (item.quantity || 1) * itemPrice;
      if (itemPrice === 0) {
        hasZeroPricedItem = true;
      }
    });
  });

  return { orderTotal, hasZeroPricedItem };
};
